import {createSelector} from 'reselect';

import {AppState} from '../../../store';
import {commonSelector}  from './../../Common/redux/selectors'
export const RoutePageSelector = (state: AppState) => state.routePage;
    
export const routePageFilterSelector = createSelector(RoutePageSelector, item => {
  return {filters:item.filters};
});
  

export const dataLoadingSelector = (state:AppState)=> {
  return state.routePage.dataLoading
  }

  export const routeDataSelector = (state:AppState)=> {
    return state.routePage.data
    }
      
export const sortBySelector = createSelector(RoutePageSelector, item => {
  return {sortBy: item.sortBy};
});
export const srpPrivateBusesSelector = createSelector(RoutePageSelector, item => {
  return {
    privateAvailableBuses: item.privateAvailableBuses,
    privateSoldOutBuses: item.privateSoldOutBuses,
    otherPrivateAvailableBuses: item.otherPrivateAvailableBuses

  };
});
export const srpRTCBusesSelector = createSelector(RoutePageSelector, item => {
  return   {rtcBuses: item.rtcBuses,otherRTCBuses:item.otherRTCBuses}
  
 
});
export const srpRTCViewSelector = createSelector(RoutePageSelector, item => {
  return { rtcView: item.rtcView}
});
   
export const srpGoSafeBannerSelector = createSelector(RoutePageSelector, item => {
  return item.goSafeData
});
export const srpRouteIdSelector = createSelector(RoutePageSelector, item => {
  return item.routeId
});

export const srpDataSelector = createSelector(RoutePageSelector, item => {
  return item.rawData
});
export const primaryFiltersInfoSelector = createSelector(RoutePageSelector, item => {
  return item.primaryFiltersInfo
});

export const filterItemsSelector= createSelector(RoutePageSelector,item=>{
  return {    isOTGApplicable:item.isOTGApplicable,
    isGosafe:item.isGosafe,
    isLiveTracking:item.isLiveTracking,
    isRedDeal:item.isRedDeal
}
})
export const dumpDataSelector = createSelector(RoutePageSelector, item => {
  return item.dumpData
});
export const bpdpDataSelector = createSelector(RoutePageSelector, item => {
  return item.bpdpData
});

export const busAvailableSelector = createSelector(
  RoutePageSelector,
  commonSelector,
  (routePageData, commonData) =>{
    const {privateAvailableBuses,privateSoldOutBuses,rtcBuses} = routePageData;
    const {journeyType} = commonData;
  
  
    const privateBuses = privateAvailableBuses[journeyType];
    const privateSoldOutBus = privateSoldOutBuses[journeyType];
    const totalRTCCount = function(){
      let count =0;
      if(rtcBuses && Object.keys(rtcBuses).length){
        for(const i in rtcBuses){
          if(rtcBuses.hasOwnProperty(i) && rtcBuses[i][journeyType]){
            count+= rtcBuses[i][journeyType].busCount;
          }
        }
      }
      return count;
    }()
    const rawBusCount = (privateBuses && privateBuses.length ? privateBuses.length : 0) + (privateSoldOutBus && privateSoldOutBus.length ? privateSoldOutBus.length : 0) + totalRTCCount
    const isBusAvailable = rawBusCount ? true : false; 
    return isBusAvailable
  } 
);
export const leaveIntentSelector = createSelector(RoutePageSelector, item => {
  return item.leaveIntentData
});